// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__mVL35","wrapper":"Loader_wrapper__3yb2F","counter":"Loader_counter__WMKky","reveal-media":"Loader_reveal-media___mphA"};